export const passwordRegExp = /^(?=.*[0-9])(?=.*[!@#$%^&*-_?])(?=.*[a-z])(?=.*[A-Z])[0-9!@#$%^&*-_?a-zA-Z]{12,}$/g;
